import Dashboard from '../containers/dashboard'
import DocumentsToReviewManagement from '../containers/documents-to-review-management'

const DocumentsToReview = () => {
  return (
    <Dashboard>
      <DocumentsToReviewManagement />
    </Dashboard>
  )
}

export default DocumentsToReview
